import { DestroyUpdater } from "./DestroyUpdater";
export async function loadDestroyUpdater(engine, refresh = true) {
    await engine.addParticleUpdater("destroy", (container) => new DestroyUpdater(engine, container), refresh);
}
